<div class="fade h-full w-full">
  <div class="border-b border-gray-300 flex justify-between zuper-dialog-header">
    <div class="primary-font font-bold text-xl text-gray-700 flex items-center pl-2">
        {{options?.drawerTitle | translate}}
    </div>
    <div class="flex justify-around">
        <a class="h-10 w-10 flex justify-center items-center hover:bg-gray-200 rounded-full cursor-pointer" (click)="closeDrawer()">
            <em class="ti ti-x text-gray-900 text-xl"></em>
        </a>
    </div>
  </div>
    
  <div class="bg-white primary-font">
    <div class="grid grid-cols-2">
      <div class="border-r border-gray-200 zuper-scrollbar" [ngClass]="details?.is_recurrence ? 'container' : 'container-without-update'">
        <nav class="mt-3 flex px-6 text-center w-full" aria-label="Tabs">
          <a (click)="leftPanelTab = 'teams';updateTempAssignedEmployees('teams');" [ngClass]="leftPanelTab === 'teams' ? 'nav-subtle-underline text-gray-700': ''" class="w-1/2 mx-2 cursor-pointer text-gray-500 hover:text-gray-700 whitespace-nowrap px-1 font-medium">{{'text.teams' | translate}} <span *ngIf="totalTeams">({{totalTeams}})</span></a>
          <a (click)="leftPanelTab = 'employees';updateTempAssignedEmployees('employees');" [ngClass]="leftPanelTab === 'employees' ? 'nav-subtle-underline text-gray-700': ''" class="w-1/2 mx-2 cursor-pointer text-gray-500 hover:text-gray-700 whitespace-nowrap px-1 font-medium"
              aria-current="page">{{'text.users' | translate}} <span *ngIf="totalEmployees">({{totalEmployees}})</span></a>
        </nav>
        <div *ngIf="leftPanelTab === 'teams'">
          <div class="flex justify-center items-center w-full p-4">
            <div class="flex justify-between items-center">
              <div class="">
                <mat-form-field appearance="fill" class="flex-shrink-0 z-10 ml-2 mt-2 w-full inline-flex items-center text-base search-type font-medium text-center text-gray-900">
                    <mat-select [(ngModel)]="type" (selectionChange)="OnSearchTypeChange($event)">
                      <mat-option [value]="option.value" *ngFor="let option of searchType"> {{option.key}} </mat-option>
                    </mat-select>
                </mat-form-field>
              </div>
              <div class="w-full mt-2 z-5">
                  <input
                      type="search"
                      class="block p-3 z-20 text-base text-gray-900 bg-white w-full rounded-r-lg border border-gray-300 border-l-0 searchinput" 
                      placeholder="{{'text.search' | translate}}"
                      [(ngModel)]="searchText" (ngModelChange)="onModelChange()" (keyup.enter)="onSearchValueChange()"
                  >
              </div>
            </div>
            <div class="flex items-center justify-center mt-2 relative" [matTooltip]="'filter.label' | translate" *ngIf="details?.service_territory?.territory?.territory_uid && isServiceTerritoryEnabled"> 
              <span class="rounded-full flex justify-center items-center h-10 w-10 ml-2 bg-gray-100 cursor-pointer" 
              [ngxTippy]="details?.service_territory?.territory?.territory_uid ? filterTeamByTerritory : null"
              [tippyName]="'filterTeamByTerritory'"
              [tippyProps]="{
              allowHTML: true,
              theme: 'light',
              trigger:'click',
              hideOnClick: false,
              interactive: true,
              placement: 'bottom'
              }">
                <em class="ti ti-filter text-3xl"></em>
              </span>
              <span class="rounded-full flex justify-center items-center h-5 w-5 text-white bg-blue-600 cursor-pointer mb-6 -ml-2 p-2" *ngIf="filterTeamBasedOnTerritory">
                  <span class="text-xs font-normal">1</span>
              </span>
            </div>
          </div>
          <!-- Error Message -->
          <div class="bg-red-50 px-4 py-3" *ngIf="this.holidayList.length > 0">
            <div class="flex items-center">
                <div class="flex-shrink-0"><em class="ti ti-alert-circle text-red-500 text-2xl"></em></div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                    <p class="text-base text-red-500">{{'job.holiday.message.prefix' | translate}} {{holidayList}}</p>
                </div>
            </div>
        </div>
          <mat-accordion *ngIf="teamsList?.length > 0">
            <ng-container *ngFor="let team of teamsList;let i=index;">
              <mat-expansion-panel class="border-b border-gray-200" #panel [expanded]="i===0 && currentTeamUid === team?.team_uid && !isLazyLoading" (afterCollapse)="onPanelCollapse($event)" (afterExpand)="onPanelExpand($event)" (click)="onExpansionPanelClicked(team)" [ngClass]="{'border-t': i===0}">
                <mat-expansion-panel-header>
                  <mat-panel-title class="flex justify-between items-center font-medium primary-font">
                    <span class="text-gray-900">{{team?.team_name}} ({{currentTeamUid === team?.team_uid ? mockTeamData?.users?.length : team?.user_count}})</span>
                    <div class="flex justify-center items-center space-x-2">
                      <div class="flex items-center justify-center" [matTooltip]="'filter.label' | translate" *ngIf="currentTeamUid === team?.team_uid && isExpanded" (click)="onFilterClicked($event)"> 
                        <span class="flex justify-center items-center cursor-pointer" 
                        [ngxTippy]="userAvailabilityFilter"
                        [tippyName]="'userAvailabilityFilter'"
                        [tippyProps]="{
                        allowHTML: true,
                        theme: 'light',
                        trigger:'click',
                        hideOnClick: false,
                        interactive: true,
                        placement: 'bottom'
                        }">
                          <em class="ti ti-filter text-2xl"></em>
                        </span>
                      </div>
                      <div class="flex items-center justify-center" [ngClass]="{'pointer-events-none':assignUserFromTeam}" [matTooltip]="'assign.all.employee' | translate" >
                        <em class="text-xl text-green-500 ti ti-user-plus" (click)="assignUserFromTeam=true;assignAllEmployeeInTeam(team,$event)"></em>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                <div *ngIf="isLazyLoading" class="inline-flex items-center justify-center h-14 w-full"> 
                  <lazy-loader *ngIf="isLazyLoading"></lazy-loader>
                </div>
                <div *ngIf="mockTeamData?.users?.length > 0 && !isLazyLoading" class="min-h-36" (click)="employeeCardClicked($event)">
                  <div class="p-4 flex hover:bg-gray-50" *ngFor="let data of mockTeamData?.users">
                    <div class="flex flex-col w-10/12" >
                      <div class="flex">
                        <div>
                          <div class="inline-flex overflow-hidden rounded-md flex-shrink-0 border-2">
                              <img *ngIf="hasValidProfilePicture(data?.profile_picture)"
                                  class="h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12"
                                  src="{{data?.profile_picture}}" alt="">
                              <div *ngIf="!hasValidProfilePicture(data?.profile_picture) && data?.first_name"
                                  class="flex items-center justify-center overflow-hidden uppercase text-4xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12">
                                  {{data?.first_name[0]}}
                              </div>
                          </div>
                        </div>
                          <div class="sm:ml-3 sm:flex-1 break-all max-w-2/4">
                              <div class="flex">
                                  <h3 
                                      class="text-lg font-bold text-gray-600 sm:text-1xl cursor-not-allowed truncate max-w-3/4"
                                      [matTooltip]="data?.first_name + ' ' + data?.last_name + ' ' + (data?.role?.role_key === 'FIELD_EXECUTIVE' ? '(FE)' : (data?.role?.role_key === 'TEAM_LEADER' ? '(TL)' : (data?.role?.role_key === 'ADMIN' ? '(ADMIN)' : '')))">
                                      {{data?.first_name}} {{data?.last_name}}</h3>
                                  <div class="w-2/12 flex items-center justify-center" [matTooltip]="'text.primary.employee' | translate" *ngIf="data?.is_primary && companyPolicy?.enable_v2_timelog && companyConfig?.jobs?.job_timelog?.is_enabled && options?.module === 'JOB'" >
                                    <mat-icon class="min-h-5 min-w-5 h-5 w-5 text-xl text-orange-700" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                  </div>
                              </div>
                              <div *ngIf="data?.email">
                                <span class="primary-font text-base">{{data?.email}}</span>
                              </div>
                              <div *ngIf="data?.workhours?.shifts?.length === 0 && data?.workhours?.start_time && data?.workhours?.end_time">
                                <span class="primary-font text-base">{{data?.workhours?.start_time | timeformat:data?.workhours?.is_utc:'HH:mm:ss'}} - {{data?.workhours?.end_time | timeformat:data?.workhours?.is_utc:'HH:mm:ss'}}</span>
                              </div>
                              <div *ngIf="data?.workhours?.shifts?.length > 0 && data?.workhours?.shifts[0].start_time && data?.workhours?.shifts[0].end_time">
                                <span class="primary-font text-base">{{data?.workhours?.shifts[0].start_time | timeformat:data?.workhours?.shifts[0]?.is_utc:'HH:mm:ss'}} - {{data?.workhours?.shifts[0].end_time | timeformat:data?.workhours?.shifts[0].is_utc:'HH:mm:ss'}}</span>
                              </div>
                              <div *ngIf="data?.workhours?.available_work_mins > 0">
                                <span class="primary-font text-base"><span>{{'text.available' | translate}} : </span><span class="text-primary">{{data?.workhours?.available_work_mins}} {{'users.preview.work_hours.mins.label' | translate}}</span></span>
                              </div>
                              <div *ngIf="companyConfig?.jobs?.alert_conflict_on_assignment !== false && data.job_conflict === true">
                                <span class="primary-font text-base text-red-500">{{'job.assignment.occupied.label' | translate}}</span>
                              </div>
                              <div *ngIf="data?.timeoff_conflict === true">
                                <span class="primary-font text-base text-red-500">{{'employee.off.error.message' | translate}}</span>
                              </div>
                              <div class="flex">
                                <ng-container  *ngIf="data?.workhours?.skills && isArrayValue(data?.workhours?.skills) && data?.workhours?.skills?.length">
                                  <ng-container *ngFor="let item of data?.workhours?.skills; let i = index">
                                    <ng-container *ngIf="item" class="status-badge">
                                      <ng-container *ngIf="i <= 1">
                                      <badge class = "my-2 mr-2" [options]="getTagBadgeOptions(item?.skillset_name)" [matTooltip] ="item?.skillset_name" [matTooltipPosition]="'below'"></badge>
                                      </ng-container>
                                      <ng-container *ngIf="i===2" >
                                        <badge class = "m-2" [options]="getTagBadgeOptions('+' + (data?.workhours?.skills?.length - 2) + ' more')"  [matTooltip]="getTagNames(data?.workhours?.skills)" [matTooltipPosition]="'below'"></badge>
                                      </ng-container>
                                    </ng-container>
                                  </ng-container>
                                </ng-container>
                              </div>
                          </div>
                      </div>
                    </div>
                    <div class="w-2/12 flex items-center justify-center" [ngClass]="{'pointer-events-none':assignUserFromTeam}" [matTooltip]="'assign.employee' | translate" *ngIf="!data?.is_assigned" >
                      <em class="text-xl text-green-500 ti ti-user-plus" (click)="assignUserFromTeam=true;assignFromTeamUser($event,data)"></em>
                    </div>
                    <div class="w-2/12 flex items-center justify-center cursor-default" [ngClass]="{'pointer-events-none':unassignUser}" [matTooltip]="'text.unassign' | translate" *ngIf="data?.is_assigned" >
                      <em class="text-xl text-red-500 ti ti-user-x" (click)="unassignUser=true;unAssignEmployee($event,data,mockTeamData?.team)"></em>
                    </div>
                  </div>
                </div>
                <div *ngIf="mockTeamData?.users?.length === 0 && !isLazyLoading" class="flex flex-col items-center justify-center primary-font py-4">
                  <img class="w-40 m-auto" src="assets/images/svgs/no_customer_found.svg"
                      alt="No Users Assigned">
                  <h4 class="font-medium mt-4 text-secondary text-base">{{'job.assignment.employees_list.placeholder' | translate}}</h4>
                </div>
                </div>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
          <div *ngIf="teamsList?.length === 0 && !isTeamsLoading" class="flex flex-col items-center justify-center primary-font py-4">
            <img class="w-40 m-auto" src="assets/images/svgs/no_customer_found.svg"
                alt="No Users Assigned">
            <h4 class="font-medium mt-4 text-secondary text-base">{{'job.assignment.team_list.placeholder' | translate}}</h4>
          </div>
          <div *ngIf="isTeamsLoading" class="inline-flex items-center justify-center h-14 w-full"> 
            <lazy-loader *ngIf="isTeamsLoading"></lazy-loader>
          </div>
          <div *ngIf="!isTeamsLoading && (teamsPage < teamsTotalPage)" class="inline-flex items-center justify-center h-14 w-full border-t border-gray-200"> 
            <span class="cursor-pointer" (click)="loadTeams()">{{'text.view_more' | translate}}</span>
          </div>
        </div>
        <div *ngIf="leftPanelTab === 'employees'">
          <div class="flex justify-center items-center w-full p-4">
            <div class="w-full mt-2 z-5">
                <input
                    type="search"
                    class="block p-3 z-20 text-base text-gray-900 bg-white w-full rounded-lg border border-gray-300 searchinput" 
                    placeholder="{{'text.search' | translate}}..."
                    [(ngModel)]="employeeSearchText" (ngModelChange)="onModelEmployeeChange()" (keyup.enter)="onSearchEmployeeValueChange()"
                >
            </div>
            <div class="flex items-center justify-center mt-2" [matTooltip]="'filter.label' | translate" *ngIf="details?.skills?.length > 0 || details?.service_territory?.territory?.territory_uid"> 
              <span class="rounded-full flex justify-center items-center h-10 w-10 ml-2 bg-gray-100 cursor-pointer" 
              [ngxTippy]="details?.skills?.length > 0 || details?.service_territory?.territory?.territory_uid ? filterEmployee : null"
              [tippyName]="'filterEmployee'"
              [tippyProps]="{
              allowHTML: true,
              theme: 'light',
              trigger:'click',
              hideOnClick: false,
              interactive: true,
              placement: 'bottom'
              }">
                <em class="ti ti-filter text-3xl"></em>
              </span>
              <span class="rounded-full flex justify-center items-center h-5 w-5 text-white bg-blue-600 cursor-pointer mb-6 -ml-2 p-2" *ngIf="filterByTerritory">
                <span class="text-xs font-normal">1</span>
            </span>
            </div>
          </div>
          <div *ngIf="employeeList.length > 0">
            <div class="p-4 flex hover:bg-gray-50" *ngFor="let data of employeeList">
              <div class="flex flex-col w-10/12">
                <div class="flex">
                  <div>
                    <div class="inline-flex overflow-hidden rounded-md flex-shrink-0 border-2">
                        <img *ngIf="hasValidProfilePicture(data?.profile_picture)"
                            class="h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12"
                            src="{{data?.profile_picture}}" alt="">
                        <div *ngIf="!hasValidProfilePicture(data?.profile_picture) && data?.first_name"
                            class="flex items-center justify-center overflow-hidden uppercase text-4xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12">
                            {{data?.first_name[0]}}
                        </div>
                    </div>
                  </div>
                    <div class="sm:ml-3 sm:flex-1 break-all max-w-2/4">
                        <div class="flex">
                            <h3
                                class="text-lg font-bold text-gray-600 sm:text-1xl cursor-not-allowed truncate max-w-3/4"
                                [matTooltip]="data?.first_name + ' ' + data?.last_name + ' ' + (data?.role?.role_key === 'FIELD_EXECUTIVE' ? '(FE)' : (data?.role?.role_key === 'TEAM_LEADER' ? '(TL)' : (data?.role?.role_key === 'ADMIN' ? '(ADMIN)' : '')))">
                                {{data?.first_name}} {{data?.last_name}}</h3>
                        </div>
                        <div *ngIf="data?.teams[0]?.team_name">
                          <span class="primary-font text-base">{{data?.teams[0]?.team_name}}</span>
                        </div>
                        <div class="flex">
                          <ng-container  *ngIf="data?.user_skills && isArrayValue(data?.user_skills) && data?.user_skills?.length">
                            <ng-container *ngFor="let item of data?.user_skills; let i = index">
                              <ng-container *ngIf="item" class="status-badge">
                                <ng-container *ngIf="i <= 1">
                                <badge class = "my-2 mr-2" [options]="getTagBadgeOptions(item?.skillsets?.skillset_name)" [matTooltip] ="item?.skillsets?.skillset_name" [matTooltipPosition]="'below'"></badge>
                                </ng-container>
                                <ng-container *ngIf="i===2" >
                                  <badge class = "m-2" [options]="getTagBadgeOptions('+' + (data?.user_skills.length - 2) + ' more')"  [matTooltip] ="getTagNames(data?.user_skills)" [matTooltipPosition]="'below'"></badge>
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>
                        <div *ngIf="data?.user?.workhours?.start_time && data?.user?.workhours?.end_time">
                          <span class="primary-font text-base">{{data?.workhours?.start_time | timeformat:data?.workhours?.is_utc:'HH:mm:ss'}} - {{data?.workhours?.end_time | timeformat:data?.workhours?.is_utc:'HH:mm:ss'}}</span>
                        </div>
                    </div>
                </div>
              </div>
              <div class="w-2/12 flex items-center justify-center" [ngClass]="{'pointer-events-none':assignUserFromEmployee}" [matTooltip]="'assign.employee' | translate" *ngIf="!data?.is_assigned">
                <em class="text-xl text-green-500 ti ti-user-plus" (click)="assignUserFromEmployee=true;assignFromEmployee(data)"></em>
              </div>
              <div class="w-2/12 flex items-center justify-center cursor-default" [ngClass]="{'pointer-events-none':unassignUser}" [matTooltip]="'text.unassign' | translate" *ngIf="data?.is_assigned" >
                <em class="text-xl text-red-500 ti ti-user-x" (click)="unassignUser=true;unAssignEmployee($event,data,data?.teams[0],'employeeList')"></em>
              </div>
            </div>
          </div>
          <div *ngIf="isEmployeeLoading" class="inline-flex items-center justify-center h-14 w-full"> 
            <lazy-loader *ngIf="isEmployeeLoading"></lazy-loader>
          </div>
          <div *ngIf="!isEmployeeLoading && (employeesPage < employeesTotalPage)" class="inline-flex items-center justify-center h-14 w-full border-t border-gray-200"> 
            <span class="cursor-pointer" (click)="loadEmployees()">{{'text.view_more' | translate}}</span>
          </div>
          <div *ngIf="employeeList?.length === 0 && !isEmployeeLoading" class="flex flex-col items-center justify-center primary-font py-4">
            <img class="w-40 m-auto" src="assets/images/svgs/no_customer_found.svg"
                alt="No Users Assigned">
            <h4 class="font-medium mt-4 text-secondary text-base">{{'job.assignment.employees_list.placeholder' | translate}}</h4>
          </div>
        </div>
      </div>
      <div class="zuper-scrollbar" [ngClass]="details?.is_recurrence ? 'container' : 'container-without-update'">
        <div class="flex justify-between items-center font-medium primary-font border-b border-gray-200 p-4">
          {{'job.assign.employee' | translate}} ({{mockAssignedEmployees?.length}})
        </div>
        <div *ngIf="mockAssignedEmployees?.length > 0">
          <ng-container class="" *ngFor="let data of mockAssignedEmployees">
            <div class="p-4 flex hover:bg-gray-50 assigned-employees">
              <div class="flex flex-col w-10/12">
                <div class="flex">
                  <div>
                    <div class="inline-flex overflow-hidden rounded-md flex-shrink-0 border-2">
                        <img *ngIf="hasValidProfilePicture(data?.user?.profile_picture)"
                            class="h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12"
                            src="{{data?.user?.profile_picture}}" alt="">
                        <div *ngIf="!hasValidProfilePicture(data?.user?.profile_picture) && data?.user?.first_name"
                            class="flex items-center justify-center overflow-hidden uppercase text-4xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12">
                            {{data?.user?.first_name[0]}}
                        </div>
                    </div>
                  </div>
                    <div class="sm:ml-3 sm:flex-1 break-all max-w-2/4">
                        <div class="flex">
                            <h3
                                class="text-lg font-bold text-gray-600 sm:text-1xl cursor-not-allowed truncate max-w-3/4"
                                [matTooltip]="data?.user?.first_name + ' ' + data?.user?.last_name + ' ' + (data?.user?.role?.role_key === 'FIELD_EXECUTIVE' ? '(FE)' : (data?.user?.role?.role_key === 'TEAM_LEADER' ? '(TL)' : (data?.role?.role_key === 'ADMIN' ? '(Admin)' : '')))">
                                {{data?.user?.first_name}} {{data?.user?.last_name}}</h3>
                        </div>
                        <div class="flex">
                          <ng-container  *ngIf="data?.user?.skills && isArrayValue(data?.user?.skills) && data?.user?.skills?.length">
                            <ng-container *ngFor="let item of data?.user?.skills; let i = index">
                              <ng-container *ngIf="item" class="status-badge">
                                <ng-container *ngIf="i <= 1">
                                <badge class = "m-2" [options]="getTagBadgeOptions(item)" [matTooltip] ="item" [matTooltipPosition]="'below'"></badge>
                                </ng-container>
                                <ng-container *ngIf="i===2" >
                                  <badge class = "m-2" [options]="getTagBadgeOptions('+' + (data?.user?.skills.length - 2) + ' more')"  [matTooltip] ="getTagNames(data?.user_skills)" [matTooltipPosition]="'below'"></badge>
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>
                        <div *ngIf="data?.team?.team_name">
                          <span class="primary-font text-base">{{data?.team?.team_name}}</span>
                        </div>
                    </div>
                </div>
              </div>
              <div class="w-2/12 flex items-center justify-center" [ngClass]="{'cursor-not-allowed': isClockedInPrimaryTechIsAssigned}" [matTooltip]="(isClockedInPrimaryTechIsAssigned ? 'text.primary.technician.restriction' : 'text.primary.employee') | translate" *ngIf="!data?.is_primary && companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled && options?.module === 'JOB'" (click)="markPrimaryTechnician(data)">
                <mat-icon class="min-h-5 min-w-5 h-5 w-5 text-xl text-orange-700" [svgIcon]="'heroicons_outline:star'"></mat-icon>
              </div>
              <div class="w-2/12 flex items-center justify-center" [ngClass]="{'cursor-not-allowed': isClockedInPrimaryTechIsAssigned}" [matTooltip]="(isClockedInPrimaryTechIsAssigned ? 'text.primary.technician.restriction' : 'text.primary.employee') | translate" *ngIf="data?.is_primary && companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled && options?.module === 'JOB'" (click)="removePrimaryTechnician(data)">
                <mat-icon class="min-h-5 min-w-5 h-5 w-5 text-xl text-orange-700" [svgIcon]="'heroicons_solid:star'"></mat-icon>
              </div>
              <div class="w-2/12 flex items-center justify-center" [ngClass]="{'cursorpointer': !((clockedInUsers?.includes(data?.user?.user_uid) && companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled) || unassignUser),'cursornotallowed':((clockedInUsers?.includes(data?.user?.user_uid) && companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled) || unassignUser)}" [matTooltip]="((clockedInUsers?.includes(data?.user?.user_uid) && companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled) ? 'text.primary.technician.restriction' : 'text.unassign') | translate">
                <em class="text-xl text-red-500 ti ti-user-x cursor-inherit" [ngClass]="{'cursorpointer': !((clockedInUsers?.includes(data?.user?.user_uid) && companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled) || unassignUser),'cursornotallowed':((clockedInUsers?.includes(data?.user?.user_uid) && companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled) || unassignUser)}" (click)="unassignUser=true;unAssignEmployee($event,data,data?.team)"></em>
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="mockAssignedEmployees?.length === 0" class="flex flex-col items-center justify-center primary-font py-4">
          <img class="w-40 m-auto" src="assets/images/svgs/no_customer_found.svg"
              alt="No Users Assigned">
          <h4 class="font-medium mt-4 text-secondary text-base">{{'sidebar.data.employees_assigned.placeholder' | translate}}</h4>
        </div>
      </div>
    </div>
    <div class="border-t border-gray-200 flex items-center space-x-2 h-14 px-4" *ngIf="details?.is_recurrence">
      <input
            type="checkbox"
            id="update" name="update" [(ngModel)]="update_all_jobs"/>
            <label for="update">{{'delete.line.item.recuurent.job.message' | translate}}</label>
    </div>
  </div>
  <div class="absolute inset-x-0 bottom-0 border-t border-gray-200 zuper-dialog-footer">
    <div class="flex justify-between">
      <div class="w-full flex items-center space-x-2" *ngIf="!options?.hideNotify">
        <input
              type="checkbox"
              id="notify" name="notify" [(ngModel)]="notify"/>
              <label for="notify">{{'job.notify.on.assign.employee' | translate}}</label>
      </div>
      <div class="flex justify-end space-x-3 ml-auto">
          <button mat-stroked-button (click)="closeDrawer()"
          class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
          {{'close.text' | translate}}</button>
          <button mat-stroked-button (click)="emitAssignedEmployee()"
              class="bg-primary btn-small px-6 items-center py-2 border b-1 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none">
              {{options?.submitButtonTitle | translate}}
          </button>
      </div>
    </div>
  </div>
</div>

<ng-template #filterEmployee let-hide>
  <div class="container tooltip fade mx-auto w-64 h-auto">
    <div class="border-b py-2">
      <p class="text-sm tooltip-title title-font uppercase ml-2">{{'apply.filter.label' | translate}}</p>
    <button
      mat-icon-button
      class="tooltip-close cursor-pointer items-center mr-2 h-6 w-6" (click)="closeTooltip()">
      <i class="ti ti-x"></i>
    </button>
    </div>
      <div class="flex space-x-4 px-4 py-2 tooltip-content" *ngIf="details?.skills?.length > 0">
        <input
        type="checkbox"
        id="skill" name="skill" [(ngModel)]="filterBySkill"/>
        <label for="skill" class="text-base font-normal cursor-pointer">{{'job.assignment.filter.by.skill' | translate}}</label>
      </div>
      <div class="flex space-x-4 px-4 py-2 tooltip-content" *ngIf="details?.service_territory?.territory?.territory_uid">
        <input
        type="checkbox"
        id="territory" name="territory" [(ngModel)]="filterByTerritory"/>
        <label for="territory" class="text-base font-normal cursor-pointer">{{'job.assignment.filter.by.territory' | translate}}</label>
      </div>
      <div class="flex justify-end border-t border-gray-300 p-2">
        <div class="flex justify-around space-x-4 bg-gray-50">
            <button (click)="onSkillFilterValueChange($event,'employee')" class="w-fit h-8 px-4 text-base flex justify-center items-center py-1 shadow-sm rounded-md text-white focus:outline-none bg-primary">
            <span class="text-md">{{'apply.text.label' | translate}}</span>
            </button>
        </div>
      </div>
    </div> 
</ng-template>

<ng-template #filterTeamByTerritory let-hide>
  <div class="container tooltip fade mx-auto w-64 h-auto">
    <div class="border-b py-2">
      <p class="text-sm tooltip-title title-font uppercase ml-2">{{'apply.filter.label' | translate}}</p>
    <button
      mat-icon-button
      class="tooltip-close cursor-pointer items-center mr-2" (click)="closeTooltip()">
      <i class="ti ti-x"></i>
    </button>
    </div>
      <div class="flex space-x-4 px-4 py-2 tooltip-content" *ngIf="details?.service_territory?.territory?.territory_uid && isServiceTerritoryEnabled">
        <input
        type="checkbox"
        id="teamTerritory" name="teamTerritory" [(ngModel)]="filterTeamBasedOnTerritory"/>
        <label for="teamTerritory" class="text-base font-normal cursor-pointer">{{'job.assignment.filter.by.territory' | translate}}</label>
      </div>
      <div class="flex justify-end border-t border-gray-300 p-2">
        <div class="flex justify-around space-x-4 bg-gray-50">
            <button (click)="onSkillFilterValueChange($event,'team')" class="w-fit h-8 px-4 text-base flex justify-center items-center py-1 shadow-sm rounded-md text-white focus:outline-none bg-primary">
            <span class="text-md">{{'apply.text.label' | translate}}</span>
            </button>
        </div>
      </div>
    </div> 
</ng-template>

<ng-template #userAvailabilityFilter let-hide>
  <div class="container tooltip fade mx-auto w-64 h-auto">
    <div class="border-b py-2">
      <p class="text-sm tooltip-title title-font uppercase ml-2">{{'apply.filter.label' | translate}}</p>
    <button
      mat-icon-button
      class="tooltip-close cursor-pointer items-center mr-2 h-6 w-6" (click)="closeTooltip()">
      <i class="ti ti-x"></i>
    </button>
    </div>
      <div class="flex space-x-4 px-4 py-2 tooltip-content">
        <input
              type="checkbox"
              id="availability" name="availability" [(ngModel)]="filterByAvailability"/>
              <label for="availability" class="text-base font-normal cursor-pointer">{{'job.assignment.filter.by.availability' | translate}}</label>
      </div>
  
      <div class="flex justify-end border-t border-gray-300 p-2">
        <div class="flex justify-around space-x-4 bg-gray-50">
            <button (click)="onAvailabilityFilterValueChange($event)" class="w-fit h-8 px-4 text-base flex justify-center items-center py-1 shadow-sm rounded-md text-white focus:outline-none bg-primary">
            <span class="text-md">{{'apply.text.label' | translate}}</span>
            </button>
        </div>
      </div>
    </div> 
</ng-template>